import { Award, Star, ShieldCheck, Home } from "lucide-react";

const stats = [
  { icon: Award, value: "17+", label: "Years in Business" },
  { icon: Star, value: "4.9", label: "Customer Rating" },
  { icon: ShieldCheck, value: "Top 2%", label: "GAF Master Elite" },
  { icon: Home, value: "10,000+", label: "Roofs Installed" },
];

export const AdsStatsBar = () => (
  <section className="bg-primary text-primary-foreground py-8">
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
        {stats.map(({ icon: Icon, value, label }) => (
          <div key={label} className="flex flex-col items-center gap-2">
            <Icon className="w-7 h-7 opacity-80" />
            <p className="text-2xl md:text-3xl font-extrabold">{value}</p>
            <p className="text-xs md:text-sm opacity-80 font-medium">{label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
